// extracted by mini-css-extract-plugin
export default {"errorFallback":"styles__errorFallback__YL_Tt","title":"styles__title__ns9xj","message":"styles__message__jOJ5x"};